import type { CitationsProps } from "@op/puck-types";
import { Dc_Text_Citation } from "@op/sf-op";
import {
  makeCitationDefinitionId,
  transformDoiOrUrl,
  useContent,
  useTranslation,
} from "@op/utils";

const Citations = (_: CitationsProps) => {
  const { citations: filteredCitations } = useContent();
  const { citation: citationTrans, citations: citationsTrans } =
    useTranslation();

  const citations = [
    ...filteredCitations.content,
    ...Object.values(filteredCitations.excursions).flatMap(
      (excursion) => excursion
    ),
  ].sort((a, b) => a.index - b.index);

  if (citations.length === 0) return null;
  return (
    <div
      id="citations"
      className="citations-print flex flex-col gap-4"
      style={{ breakBefore: "page" }}
    >
      <h2 className="text-heading-2 font-heading-2 text-default-font">
        {citationsTrans.citations}
      </h2>
      <div className="flex flex-col gap-1">
        {citations.map((citation, index) => {
          const content = (
            <>
              [{citation.index.toString()}] {citation.content}{" "}
              {citation.source ? (
                <a
                  target="_blank"
                  href={
                    citation.source
                      ? transformDoiOrUrl(citation.source)
                      : undefined
                  }
                >
                  <Dc_Text_Citation.SourceButton>
                    {citationTrans.viewSource}
                  </Dc_Text_Citation.SourceButton>
                </a>
              ) : null}
            </>
          );

          return (
            <div
              key={index}
              id={makeCitationDefinitionId(citation.index)}
              className="text-caption font-caption leading-snug"
            >
              {content as unknown as string}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Citations;
